import { useEffect, useLayoutEffect, useReducer } from "react";
import { checkResizeObserver } from "./checkResizeObserver.js";
checkResizeObserver();
function messengerReducer(state, action) {
  const { type } = action;
  switch (type) {
    case "resize": {
      const { width, height } = action;
      return { ...state, width, height };
    }
    case "startResizing":
      return { ...state, resizing: true };
    case "endResizing":
      return { ...state, resizing: false };
    default:
      throw Error(`Unknown action: ${JSON.stringify(action)}`);
  }
}
function useElementSize(element, resizingThreshold = 500) {
  const [elementSize, dispatch] = useReducer(messengerReducer, {
    width: element?.offsetWidth ?? 0,
    height: element?.offsetHeight ?? 0,
    resizing: false
  });
  const { width, height } = elementSize;
  useLayoutEffect(() => {
    if (!element?.parentElement) return;
    let rafId;
    let observer = new ResizeObserver((entries) => {
      if (entries.length === 0) {
        throw new Error("No UI elements registered to the useElementSize. This is a no-op.");
      }
      if (entries.length > 1) {
        throw new Error("Multiple UI elements registered to the useElementSize. This is a no-op.");
      }
      const entry = entries[0];
      rafId = window.requestAnimationFrame(() => {
        const {
          contentRect: { width: width2, height: height2 }
        } = entry;
        dispatch({ type: "resize", width: width2, height: height2 });
      });
    });
    observer.observe(element.parentElement);
    return () => {
      observer?.observe(element);
      observer?.disconnect();
      observer = null;
      if (rafId) window.cancelAnimationFrame(rafId);
    };
  }, [element]);
  useEffect(() => {
    width;
    height;
    if (resizingThreshold <= 0) return;
    dispatch({ type: "startResizing" });
    const timer = setTimeout(() => {
      dispatch({ type: "endResizing" });
    }, resizingThreshold);
    return () => {
      clearTimeout(timer);
    };
  }, [resizingThreshold, width, height]);
  return elementSize;
}
export {
  useElementSize
};
//# sourceMappingURL=useElementSize.js.map
